import React, { ComponentProps, memo, useRef } from 'react'

import styled from '@emotion/styled'

import { useBodyScrollLock } from '@surglogs-app/hooks'
import { FlexBox, fadeIn, LayerManager } from '@surglogs-app/ui'

const DialogBackgroundContainer = styled(FlexBox)`
  background-color: ${({ bgc, theme }) => bgc ?? theme.ui.colors.overlay};
  animation: ${fadeIn} ${({ theme }) => theme.ui.motion.duration.normal}
    ${({ theme }) => theme.ui.motion.easing.decelerate};
`

export const DialogBackground = memo(
  ({ children, ...rest }: ComponentProps<typeof FlexBox>) => {
    const ref = useRef<HTMLDivElement>(null)
    useBodyScrollLock(ref)

    return (
      <LayerManager>
        {({ zIndex, increaseBy }) => (
          <DialogBackgroundContainer
            {...{
              ref,
              zi: 1 + zIndex + increaseBy,
              position: 'fixed',
              top: '0',
              left: '0',
              w: '100%',
              h: '100%',
              overflow: 'hidden',
              ai: 'center',
              jc: 'center',
              ...rest,
            }}>
            {children}
          </DialogBackgroundContainer>
        )}
      </LayerManager>
    )
  },
)
